import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/Services/login.service';
import { EmployeeloginService } from 'src/app/Services/employeelogin.service';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { EmployeeCredentials } from 'src/app/employee-credentials';
import { EmployeeData, UserData } from 'src/app/Models/employee-and-user-data';
import { AuthTokenService } from 'src/app/Services/auth-token/auth-token.service';
import { readStoredClientIp } from 'src/app/utils/client-ip-storage';

@Component({
  selector: 'app-admin-login-page',
  templateUrl: './admin-login-page.component.html',
  styleUrls: ['./admin-login-page.component.css'],
})
export class AdminLoginPageComponent implements OnInit {
  public shipname = '';
  public rebcode = '';
  public busSvcURL = '';
  public evtuid = 0;
  public rebuid = 0;
  public shipid = 0;
  public evtcode = '';
  public userData = {};
  public loginmessage = '';

  logincredentials = new EmployeeCredentials();
  Logindata: any;
  EmployeeData: EmployeeData[] = [];
  userdata?: UserData;
  employeedata?: EmployeeData;
  RecordAccessData: any;

  constructor(
    private authTokenSvc: AuthTokenService,
    private appConfigService: AppConfigService,
    private router: Router,
    private loginservice: LoginService,
    private employeeloginservice: EmployeeloginService
  ) { }

  ngOnInit(): void {
  }

  login(event?: MouseEvent) {
    this.loginmessage = '';
    //call service to validate credentials and return global attributes
    const usercredentials: EmployeeCredentials = new EmployeeCredentials();
    usercredentials.EmployeeNo = this.logincredentials.EmployeeNo;
    usercredentials.LastName = this.logincredentials.LastName;

    this.Logindata = this.employeeloginservice
      .GetEmployeeLogin(
        //will be new service (calls the view jeff creates)
        this.logincredentials.EmployeeNo,
        this.logincredentials.LastName
      )
      .subscribe((Logindata) => this.setLogin(Logindata));
  }

  setLogin(resdata: any) {
    this.Logindata = resdata;
    //this.Logindata = resdata.GetPortalLogin.Result.status;
    if (this.Logindata.GetEmployeeLogin.Result.Status == 'A') {
      this.EmployeeData = this.Logindata.GetEmployeeLogin.EmployeeLoginList;

      // IF THE LOGIN REQUEST CONTAINS AN AUTHENTICATION TOKEN FOR OUR END USER THEN STORE THAT TOKEN FOR THE END USER...
      if (resdata.GetEmployeeLogin.Token != "") this.authTokenSvc.setToken(resdata.GetEmployeeLogin.Token);
     
      //set global attributes
      this.employeedata = {
        EmployeeNo: this.EmployeeData[0].EmployeeNo,
        LastName: this.EmployeeData[0].LastName,
      };
      localStorage.setItem('eeinfo', JSON.stringify(this.employeedata));
      this.recordEmployeeLoginAccess();
      this.router.navigate(['/shipselect']); //STOP READING
    } else {
      // if (this.Logindata.GetEmployeeLogin.Result.Status == 'R')
      this.loginmessage = 'Invalid Login - Access only for active employees';
      //alert('Login Failed');
    }
    if (event) {
      event.stopPropagation();
    }
  }
  /** IP from storage if available (e.g. reused session); else omit (no client-side IP lookup). */
  private recordEmployeeLoginAccess(): void {
    const ip = readStoredClientIp();

    if (ip == undefined || ip == null || ip == '') {
      console.error("Unable to extract end users ip address.");
      return;
    }
      
    this.RecordAccessData = this.loginservice
      .RecordAccess(
        this.logincredentials.EmployeeNo,
        true,
        ip,
        'Employee',
        'login'
      )
      .subscribe((recordAccessdata) => this.setRecordAccess(recordAccessdata));
  }
  setRecordAccess(resdata: any) {
    this.RecordAccessData = resdata;
    if (this.RecordAccessData.ResRecordAccess.Result.Status == 'A') {
    }
  }
}
